import {useMutation, useQuery} from "vue-query";
import {unref} from "vue";
import {useProduct} from "../hooks/useProduct";
import {queryClient} from "../client";

const {
  getProducts: getProductsRequest,
  getProduct: getProductRequest,
  update: updateRequest,
} = useProduct();

export const getProducts = (params = {}, options) => useQuery(['products', params], () => getProductsRequest(unref(params)), options);
export const getProduct = (id, options) => useQuery(['products', id], () => getProductRequest(unref(id)), options);
export const updateProduct = () => useMutation('products', ({id, data}) => updateRequest(id, data), {
  onSuccess: (response) => {
    queryClient.setQueryData(['products', response.data.id], () => response);
  }
})

